export function getSearchParams(
  paramString: string = window.location.search.split("?")[1]
): { [key: string]: string } {
  return [...new URLSearchParams(paramString).entries()].reduce(
    (acc, [key, val]) => {
      acc[key] = decodeURIComponent(val);
      return acc;
    },
    {}
  );
}
